import { Link } from 'react-router-dom';
import { 
  HiUsers,
  HiDeviceMobile,
  HiCode,
  HiTrendingUp,
  HiShieldCheck,
  HiMail,
  HiCurrencyDollar
} from 'react-icons/hi';
import { FaTelegram, FaLaptopCode, FaTrophy } from 'react-icons/fa';
import { MdStadium, MdControlPoint, MdManageAccounts } from 'react-icons/md';
import { GiUnicorn } from 'react-icons/gi';
import { RiAdvertisementFill } from 'react-icons/ri';
import { PiBasketballFill } from 'react-icons/pi';
import { useLanguage } from '@/contexts/LanguageContext';
import './Investors.css';

export default function Investors() {
  const { t } = useLanguage();
  return (
    <div className="investors-page">
      {/* Hero Section */}
      <section className="investors-hero">
        <div className="hero-background-overlay"></div>
        <div className="container">
          <div className="hero-content">
          <h1 className="investors-hero-title">
              {t('investors.hero.title')}
          </h1>
          <p className="investors-hero-subtitle">
              {t('investors.hero.subtitle')}
            </p>
            <div className="hero-actions">
              <a href="#contact" className="btn btn-outline btn-large">
                {t('investors.hero.contactButton')}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Key Metrics Section */}
      <section className="investors-metrics">
        <div className="container">
          <h2 className="section-title">{t('investors.metrics.title')}</h2>
          <div className="metrics-grid">
            <div className="metric-card">
              <div className="metric-icon">
                <MdStadium />
              </div>
              <div className="metric-value">12 000+</div>
              <div className="metric-label" dangerouslySetInnerHTML={{ __html: t('investors.metrics.sportsObjects') }}></div>
            </div>
            <div className="metric-card">
              <div className="metric-icon">
                <HiDeviceMobile />
              </div>
              <div className="metric-value">10 000+</div>
              <div className="metric-label" dangerouslySetInnerHTML={{ __html: t('investors.metrics.historicalUsers') }}></div>
            </div>
            <div className="metric-card">
              <div className="metric-icon">
                <FaTelegram />
              </div>
              <div className="metric-value">{t('investors.metrics.telegramBotActive')}</div>
              <div className="metric-label" dangerouslySetInnerHTML={{ __html: t('investors.metrics.telegramBot') }}></div>
            </div>
            <div className="metric-card">
              <div className="metric-icon">
                <HiUsers />
              </div>
              <div className="metric-value">1 500+</div>
              <div className="metric-label" dangerouslySetInnerHTML={{ __html: t('investors.metrics.communityMembers') }}></div>
            </div>
            <div className="metric-card">
              <div className="metric-icon">
                <HiCode />
              </div>
              <div className="metric-value">{t('investors.metrics.ready')}</div>
              <div className="metric-label" dangerouslySetInnerHTML={{ __html: t('investors.metrics.mobileApp') }}></div>
            </div>
            <div className="metric-card">
              <div className="metric-icon">
                <GiUnicorn />
              </div>
              <div className="metric-value">{t('investors.metrics.unique')}</div>
              <div className="metric-label" dangerouslySetInnerHTML={{ __html: t('investors.metrics.sync') }}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="investors-timeline">
        <div className="container">
          <h2 className="section-title">{t('investors.timeline.title')}</h2>
          <p className="section-subtitle">
            {t('investors.timeline.subtitle')}
          </p>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">{t('investors.timeline.2018-2020.year')}</div>
              <div className="timeline-content">
                <h3 className="timeline-title">{t('investors.timeline.2018-2020.title')}</h3>
                <p className="timeline-description">
                  {t('investors.timeline.2018-2020.description')}
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t('investors.timeline.2020-2023.year')}</div>
              <div className="timeline-content">
                <h3 className="timeline-title">{t('investors.timeline.2020-2023.title')}</h3>
                <p className="timeline-description">
                  {t('investors.timeline.2020-2023.description')}
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t('investors.timeline.2024.year')}</div>
              <div className="timeline-content">
                <h3 className="timeline-title">{t('investors.timeline.2024.title')}</h3>
                <p className="timeline-description">
                  {t('investors.timeline.2024.description')}
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t('investors.timeline.2025.year')}</div>
              <div className="timeline-content">
                <h3 className="timeline-title">{t('investors.timeline.2025.title')}</h3>
                <p className="timeline-description">
                  {t('investors.timeline.2025.description')}
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t('investors.timeline.2025-2026.year')}</div>
              <div className="timeline-content">
                <h3 className="timeline-title">{t('investors.timeline.2025-2026.title')}</h3>
                <p className="timeline-description">
                  {t('investors.timeline.2025-2026.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Market Opportunity Section */}
      <section className="investors-market">
        <div className="container">
          <h2 className="section-title">{t('investors.market.title')}</h2>
          <div className="market-content">
            <div className="market-text">
              <h3 className="market-subtitle">{t('investors.market.growingInterest.title')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('investors.market.growingInterest.text') }}></p>
              
              <h3 className="market-subtitle">{t('investors.market.fragmented.title')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('investors.market.fragmented.text') }}></p>
              
              <h3 className="market-subtitle">{t('investors.market.activeGrowth.title')}</h3>
              <p>{t('investors.market.activeGrowth.text')}</p>
              
              <h3 className="market-subtitle">{t('investors.market.opportunity.title')}</h3>
              <p>{t('investors.market.opportunity.text')}</p>
              
              <p className="market-conclusion" dangerouslySetInnerHTML={{ __html: `<strong>${t('investors.market.conclusion').split(' — ')[0]}</strong> — ${t('investors.market.conclusion').split(' — ')[1]}` }}></p>
            </div>
          </div>
              </div>
      </section>

      {/* Problem & Solution Section */}
      <section className="investors-problem">
        <div className="container">
          <div className="problem-solution-grid">
            <div className="problem-block">
              <h2 className="section-title">{t('investors.problem.title')}</h2>
              <ul className="problem-list">
                <li>{t('investors.problem.items.findVenue')}</li>
                <li>{t('investors.problem.items.gatherTeam')}</li>
                <li>{t('investors.problem.items.noUnified')}</li>
                <li>{t('investors.problem.items.noAutomation')}</li>
              </ul>
              </div>
            <div className="solution-block">
              <h2 className="section-title">{t('investors.solution.title')}</h2>
              <ul className="solution-list">
                <li>{t('investors.solution.items.unifiedBase')}</li>
                <li>{t('investors.solution.items.search')}</li>
                <li>{t('investors.solution.items.meetings')}</li>
                <li>{t('investors.solution.items.subscriptions')}</li>
                <li>{t('investors.solution.items.telegramBot')}</li>
                <li>{t('investors.solution.items.adminTools')}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Now Section */}
      <section className="investors-timing">
        <div className="container">
          <h2 className="section-title">{t('investors.whyNow.title')}</h2>
          <p className="section-subtitle">
            {t('investors.whyNow.subtitle')}
          </p>
          <div className="timing-grid">
            <div className="timing-card">
              <HiShieldCheck className="timing-icon" />
              <h3 className="timing-title">{t('investors.whyNow.freeMarket.title')}</h3>
              <p className="timing-description">
                {t('investors.whyNow.freeMarket.description')}
              </p>
              </div>
            <div className="timing-card">
              <HiTrendingUp className="timing-icon" />
              <h3 className="timing-title">{t('investors.whyNow.growingDemand.title')}</h3>
              <p className="timing-description">
                {t('investors.whyNow.growingDemand.description')}
              </p>
            </div>
            <div className="timing-card">
              <FaLaptopCode className="timing-icon" />
              <h3 className="timing-title">{t('investors.whyNow.techReady.title')}</h3>
              <p className="timing-description">
                {t('investors.whyNow.techReady.description')}
              </p>
            </div>
            <div className="timing-card">
              <HiCurrencyDollar className="timing-icon" />
              <h3 className="timing-title">{t('investors.whyNow.lowCost.title')}</h3>
              <p className="timing-description">
                {t('investors.whyNow.lowCost.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Product Features Section */}
      <section className="investors-product">
        <div className="container">
          <h2 className="section-title">{t('investors.product.title')}</h2>
          <p className="section-subtitle">
            {t('investors.product.subtitle')}
          </p>
          <div className="product-features">
            <div className="product-feature">
              <HiDeviceMobile className="feature-icon" />
              <h3 className="feature-title">{t('investors.product.mobileApp')}</h3>
              <p className="feature-description">{t('investors.product.mobileAppDesc')}</p>
            </div>
            <div className="product-feature">
              <HiCode className="feature-icon" />
              <h3 className="feature-title">{t('investors.product.dataCore')}</h3>
              <p className="feature-description">{t('investors.product.dataCoreDesc')}</p>
            </div>
            <div className="product-feature">
              <MdManageAccounts className="feature-icon" />
              <h3 className="feature-title">{t('investors.product.adminPanel')}</h3>
            </div>
            <div className="product-feature">
              <PiBasketballFill className="feature-icon" />
              <h3 className="feature-title">{t('investors.product.sportChannels')}</h3>
            </div>
            <div className="product-feature">
              <FaLaptopCode className="feature-icon" />
              <h3 className="feature-title">{t('investors.product.webVersion')}</h3>
            </div>
            <div className="product-feature">
              <FaTelegram className="feature-icon" />
              <h3 className="feature-title">{t('investors.product.telegramBot')}</h3>
              <p className="feature-description">{t('investors.product.telegramBotDesc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Monetization Section */}
      <section className="investors-monetization">
        <div className="container">
          <h2 className="section-title">{t('investors.monetization.title')}</h2>
          <div className="monetization-grid">
            <div className="monetization-item">
              <HiCurrencyDollar className="monetization-icon" />
              <h3 className="monetization-title">{t('investors.monetization.rentalCommissions')}</h3>
            </div>
            <div className="monetization-item">
              <FaTrophy className="monetization-icon" />
              <h3 className="monetization-title">{t('investors.monetization.tournaments')}</h3>
              <p className="monetization-description">{t('investors.monetization.tournamentsDesc')}</p>
            </div>
            <div className="monetization-item">
              <MdControlPoint className="monetization-icon" />
              <h3 className="monetization-title">{t('investors.monetization.b2bSubscriptions')}</h3>
              <p className="monetization-description">{t('investors.monetization.b2bSubscriptionsDesc')}</p>
            </div>
            <div className="monetization-item">
              <RiAdvertisementFill className="monetization-icon" />
              <h3 className="monetization-title">{t('investors.monetization.advertising')}</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Financial Goals Section */}
      <section className="investors-financial">
        <div className="container">
          <h2 className="section-title">{t('investors.financial.title')}</h2>
          <div className="financial-content">
            <div className="financial-card">
              <h3 className="financial-card-title">{t('investors.financial.round')}</h3>
              <div className="financial-details">
                <div className="financial-item">
                  <span className="financial-label">{t('investors.financial.request')}</span>
                  <span className="financial-value">{t('investors.financial.amount')}</span>
                </div>
                <div className="financial-item">
                  <span className="financial-label">{t('investors.financial.useOfFunds')}</span>
                  <div className="financial-breakdown">
                    <div className="breakdown-item">
                      <span className="breakdown-percent">{t('investors.financial.marketing')}</span>
                      <span className="breakdown-text">{t('investors.financial.marketingText')}</span>
                    </div>
                    <div className="breakdown-item">
                      <span className="breakdown-percent">{t('investors.financial.product')}</span>
                      <span className="breakdown-text">{t('investors.financial.productText')}</span>
                    </div>
                    <div className="breakdown-item">
                      <span className="breakdown-percent">{t('investors.financial.operations')}</span>
                      <span className="breakdown-text">{t('investors.financial.operationsText')}</span>
                    </div>
                </div>
                </div>
                <div className="financial-item">
                  <span className="financial-label">{t('investors.financial.goals')}</span>
                  <ul className="financial-goals">
                    <li>{t('investors.financial.goal1')}</li>
                    <li>{t('investors.financial.goal2')}</li>
                    <li>{t('investors.financial.goal3')}</li>
                    <li>{t('investors.financial.goal4')}</li>
                    <li>{t('investors.financial.goal5')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="investors-team">
        <div className="container">
          <h2 className="section-title">{t('investors.team.title')}</h2>
          <div className="team-content">
            <div className="team-card">
              <h3 className="team-title">{t('investors.team.founder')}</h3>
              <p className="team-description" dangerouslySetInnerHTML={{ __html: t('investors.team.experience') }}></p>
              <p className="team-description">
                {t('investors.team.support')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="investors-contact">
        <div className="container">
          <h2 className="section-title">{t('investors.contact.title')}</h2>
          <p className="contact-subtitle">
            {t('investors.contact.subtitle')}
          </p>
          <div className="contact-actions">
            <a href="mailto:ag@sportsground.ru" className="btn btn-primary btn-large">
              {t('investors.contact.contactButton')}
            </a>
            <a href="mailto:ag@sportsground.ru?subject=Запрос на Pitch Deck" className="btn btn-outline btn-large">
              {t('investors.contact.presentationButton')}
            </a>
          </div>
          <div className="contact-info">
            <div className="contact-item">
              <HiMail className="contact-icon" />
              <div>
                <div className="contact-label">{t('investors.contact.email')}</div>
                <a href="mailto:ag@sportsground.ru" className="contact-value">
                  ag@sportsground.ru
                </a>
              </div>
            </div>
            <div className="contact-item">
              <FaTelegram className="contact-icon" />
              <div>
                <div className="contact-label">{t('investors.contact.telegram')}</div>
                <a href="https://t.me/plschdk_bot" target="_blank" rel="noopener noreferrer" className="contact-value">
                  @plschdk_bot
                </a>
              </div>
            </div>
          </div>
          <div className="contact-footer">
            <Link to="/" className="contact-link">
              {t('investors.contact.backToHome')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
